import { ca } from '@cian/analytics';

export type TPhoneOpenActionType = 'Open_compare_listing' | 'Open_compare_flatplan';

interface ITrackPhoneOpen {
  action: TPhoneOpenActionType;
  label: string;
  offerId: number;
}

export function trackPhoneOpen({ action, label, offerId }: ITrackPhoneOpen) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action,
    label,
    products: [{ id: offerId, offerType: 'offer' }],
  });
}
